export default __webpack_public_path__ + "static/media/KBM04562-op.ed03497d.webp";